export default {

  getAllAnalysis(filter) {
    return env.API.post('/test/water/analysis/all', filter);
  },

  getAlanysis(analisis) {
    return env.API.get('/test/water/analysis/get', {
      params: {
        waterAnalysisId: analisis
      }
    });
  },

  create(data) {
    return env.API.post('/test/water/create', data);
  },

  save(id, data) {
    // TODO: refactor
    return env.API.post('/test/water/update/' + id, {
      ...data,
      waterAnalisysId: id,
    });
  },

  remove(analisis) {
    return env.API.post(`/test/water/delete`, {
      waterAnalysisId: analisis
    });
  },

  downloadReport(id) {
    return env.API.get('test/water/' + id + '/report');
  },
}
